<template>
  <!-- 产品类别区：3×2 网格（在宽高比 ≤ 1:1 时切换为 1×6）；每项包含标题覆盖层与两个链接按钮。
       历史要求记录：标题位置上移（top 百分比）；字体统一通过 --overlay-scale 放大。 -->
  <div class="categorie-container" :style="{ height: height + 'px' }">
    <div class="categorie-grid">
      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=34" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/1.jpeg" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/1.jpeg" alt="Category 1">
        </a>
                <!-- </div> -->
      </div>
      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=39" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/2.jpg" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/2.jpg" alt="Category 2">
        </a>
                <!-- </div> -->
      </div>
      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=33" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/3.jpeg" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/3.jpeg" alt="Category 3">
        </a>
                <!-- </div> -->
      </div>
      
      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=32" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/4.jpg" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/4.jpg" alt="Category 4">
        </a>
                <!-- </div> -->
      </div>

      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=35" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/红箭10.jpg" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/红箭10.jpg" alt="Category 5">
        </a>
                <!-- </div> -->
      </div>
      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=37" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/RESKIT.jpg" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/RESKIT.jpg" alt="Category 6">
        </a>
                <!-- </div> -->
      </div>
      <div class="categorie-item">
        <a class="categorie-link" href="https://b.zimimodel.com/web/#/pages/goods-search/goods-search?brand=38" target="_blank" rel="noopener noreferrer">
          <img class="img-bg" src="@/assets/categorie_image/ScaleX.png" alt="" aria-hidden="true">
          <img class="img-main" src="@/assets/categorie_image/ScaleX.png" alt="Category 7">
        </a>
                <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
})
export default class CategorieImg extends Vue {}
</script>

<style scoped lang="scss">
/* 样式已包含响应式网格、覆盖层与自适应字体说明；保持注释与图片/视频轮播一致。 */
.categorie-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 20px; /*分类图四周外白边距*/
  box-sizing: border-box;
  /* 覆盖层字体放大因子（可按需调整）
   * 历史要求记录：用户曾反馈标题偏小，图片/视频轮播区通过变量统一放大；
   * 此处保持一致，默认放大 20%。
   */
  --overlay-scale: 1.2;
}

.categorie-grid {
  display: grid;
  /* 因需求变更（2026-03），重新改回强制单列显示，暂时注释 2 列自适应相关代码 */
  /* grid-template-columns: repeat(2, 1fr); */
  /* 因现有 7 个分类项，2列布局需 4 行才能容纳，故改为 repeat(4, 1fr) 以确保高度平均分配 */
  /* grid-template-rows: repeat(4, 1fr); */
  grid-template-columns: 1fr;
  grid-template-rows: repeat(7, 1fr);
  /* 因用户要求图与图之间上下留白增加到 2 倍，故由 10px 改为 20px；左右保持 10px */
  gap: 20px 20px;
  width: 100%;
  height: 100%;
}

/* 注释掉媒体查询，因为现在统一使用单列显示 */
/*
@media (max-aspect-ratio: 1/1) {
  .categorie-grid {
    grid-template-columns: 1fr;
    // 因现有 7 个分类项，1列布局需 7 行才能容纳，故改为 repeat(7, 1fr) 以确保高度平均分配
    grid-template-rows: repeat(7, 1fr);
  }
}
*/

.categorie-item {
  position: relative; /* 便于覆盖层进行绝对定位 */
  overflow: hidden;
  /* 因优化样式（2026-03），将图片容器改为圆角矩形 */
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.categorie-link {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(20px);
  transform: scale(1.12);
}

.img-main {
  position: relative;
  z-index: 1;
  width: auto;
  height: 100%;
  object-fit: contain;
  display: block;
}

</style>
